import AjaxResolver from 'owd/module/ajax';

export default class PortfolioResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('[data-portfolio-container]').outerHeight($('[data-portfolio-container]').prop('newHeight'));

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();

		$('[data-portfolio-container]').transition({
			opacity: .5
		}, 600, 'ease-out', () => {
			deferred.resolve();
		});

		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		let $newContainer = $loadedContent.find('[data-portfolio-container]');
		let $currentContainer = $('[data-portfolio-container]');

		$currentContainer.after($newContainer);

		$newContainer.prop('newHeight', $newContainer.outerHeight());

		$newContainer.outerHeight($currentContainer.outerHeight());

		$currentContainer.remove();

		deferred.resolve($currentContainer, $newContainer);

		return deferred.promise();
	}
}
